export default __webpack_public_path__ + "static/media/metamask.4f06ed22.png";